import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Container, AccordionHeader, AccordionBody, InputFieldsWrapper } from '.././PTPlusStyled'
import TextInput from 'web/components/form-elements/TextInput';
import NumberInput from 'web/components/form-elements/NumberInput';
import RadioButton from 'web/components/form-elements/RadioButton';
import { Field } from 'formik'
import { Table } from 'reactstrap';
import AlertModal from "web/components/AlertModal";
import Select from 'web/components/form-elements/Select';
import states from 'states-us';
import DownloadIcon from "web/assets/svg/DownloadIcon";
import GetCetModal from "web/components/GetCetModal";
import EditIcon from "web/assets/svg/PtPlusUserViewEditIcon";
import AddPlusIcon from "web/assets/svg/PtPlusUserAddPlusIcon";
import { certificateListDetails } from "redux/actions/adminPtPlus";
import { downloadFile } from 'redux/actions/helper/downloadFile';

function TaxExemption(pageProps) {
  const [accordionOpen, setAccordionOpen] = useState(false)
  const [tableData, setTableData] = useState([])
  const dispatch = useDispatch();
  let history = useHistory();
  const token = localStorage.getItem("token");

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);
  let title = "";

  const [genCetModal, setGenCetModal] = useState(false);
  const genCetToggleModal = () => setGenCetModal(!genCetModal);

  const [genCetListResponse, setGenCetListResponse] = useState(undefined);
  const [stateVal, setStateVal] = useState("New York");
  const authId = localStorage.getItem("adminAuthId");

  const getCertTableDataAPI = async () => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      let response = await dispatch(certificateListDetails(token, pageProps.pageData.id));
      setGenCetListResponse(response.value);
    }
  };
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      getCertTableDataAPI();
    }
  }, []);


  const territoryStates = states.filter((x) => x.contiguous);
  let stateArr = []
  for (let i = 0; i < territoryStates.length; i++) {
    if (territoryStates[i].name !== 'District Of Columbia') {
      let obj = {
        value: territoryStates[i].name,
        label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
        isoCode: territoryStates[i].abbreviation
      }
      stateArr.push(obj)
    }
  }

  let headerArr = [
    { title: 'State', },
    { title: 'Signed Date', },
    { title: 'Expiration Date', },
    { title: 'Status', },
    { title: 'Document', },
  ];

  const downloadDocuments = async (genCetId) => {
    const fileUrl = process.env.REACT_APP_PT_PLUS_API_URL + "ptms/tax/download_certificate?id=" + pageProps.pageData.id + "&c_id=" + genCetId;
    dispatch(downloadFile('tax-exemption-certificate.pdf', fileUrl, token, 'ptplus'));
    // if (token === null) {
    //   setModalContent("Please Sign In again.");
    //   setModalLink('/sign-in');
    //   toggleModal();
    // } else {
    //   const fileUrl =
    //     process.env.REACT_APP_PT_PLUS_API_URL +
    //     "ptms/tax/download_certificate?id=" +
    //     pageProps.pageData.id +
    //     "&c_id=" +
    //     genCetId;
    //   window.open(fileUrl);
    // }
  };
  return (
    <>
      <Container>
        <AccordionHeader>
          <h6 onClick={() => {
            if (accordionOpen) setAccordionOpen(false)
            else setAccordionOpen(true)
          }}>Manage Tax Exemption</h6>
          {accordionOpen ?
            <h4 onClick={() => setAccordionOpen(false)}><i></i></h4>
            : <h5 onClick={() => setAccordionOpen(true)}><i></i></h5>
          }
        </AccordionHeader>
        {accordionOpen &&
          <AccordionBody>
            <InputFieldsWrapper>
              <h6 style={{ fontWeight: 'bold', fontSize: '15px', color: '#000' }}>Tax Exemption</h6>
              <p style={{ color: '#000000', marginTop: '15px', 'font-size': '15px' }}>State<span className="star">&#42;</span></p>

              <div style={{ display: 'flex', marginBottom: '20px' }}>
                <Select
                  name="stateTaxExemption"
                  placeholder='State'
                  data={stateArr}
                  searchable={true}
                  onChangeHandler={(data) => {
                    setStateVal(data.value);
                  }}
                />
                <button style={{ height: '38px', marginLeft: '10px' }} className='green-button' onClick={(e) => {
                  if (stateVal) {
                    genCetToggleModal();
                  } else {
                    setModalContent("Please select state first.");
                    setModalLink("");
                    toggleModal();
                  }
                }}>Exemption Form</button>
              </div>
              <div>
                <Table responsive>
                  <thead>
                    <tr>
                      <th>State</th>
                      <th>Signed Date</th>
                      <th>Expiration Date</th>
                      <th>Status</th>
                      <th
                        className="text-center"
                        style={{ width: "137px" }}
                      >
                        Document
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* <tr key={1} className='flat-fee-table-data'>
                                            <td>name</td>
                                            <td>pallet details, pallet details, pallet details</td>
                                            <td>$ 50</td>
                                            <td>12/12/2023</td>
                                            <td>12/12/2023</td>
                                        </tr>
                                        <tr key={2} className='flat-fee-table-data'>
                                            <td>name</td>
                                            <td>pallet details, pallet details, pallet details</td>
                                            <td>$ 50</td>
                                            <td>12/12/2023</td>
                                            <td>12/12/2023</td>
                                        </tr>
                                        <tr key={3} className='flat-fee-table-data'>
                                            <td>name</td>
                                            <td>pallet details, pallet details, pallet details</td>
                                            <td>$ 50</td>
                                            <td>12/12/2023</td>
                                            <td>12/12/2023</td>
                                        </tr>
                                        {
                                            tableData && tableData.map((items, index) => (
                                                <tr key={index} className='user-list-table-data'>

                                                </tr>
                                            ))} */}
                    {genCetListResponse &&
                      genCetListResponse.map((data, index) => {
                        return (
                          <tr>
                            <th>{data.exposureZone.name}</th>
                            <th>{data.signedDate}</th>
                            <th>{data.expirationDate}</th>
                            <th>{data.status}</th>
                            <th className="text-center">
                              <button
                                className="download-btn"
                                onClick={() => {
                                  downloadDocuments(data.id)
                                }}
                              >
                                <DownloadIcon />
                              </button>
                              {/* <span style={{ color: '#87CDf1', cursor: 'pointer' }} onClick={() => downloadDocuments(data.id)}>{data.filename}</span> */}
                            </th>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </div>
            </InputFieldsWrapper>
            {/* <div className='view-edit-button-section'>
                            <button className='save-button' onClick={() => { }}><EditIcon />Update</button>
                            <button className='cancel-button'>Cancel</button>
                        </div> */}
          </AccordionBody>
        }

        {genCetModal && (
          <GetCetModal
            isOpen={genCetModal}
            toggle={genCetToggleModal}
            title={""}
            id={pageProps.pageData.id}
            selectedState={stateVal}
            onClickHander={(val) => {
              genCetToggleModal();
            }}
            callBack={() => {
              getCertTableDataAPI();
              genCetToggleModal();
            }}
            getCetType="PTMS"
            content={""}
            link={""}
          />
        )}

        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title={title}
          content={modalContent}
          // alertType={alertTypeState}
          link={modalLink}
          callBackAlert={(val) => {
            // if (val !== "failure") {
            //     fetchMyAPI();
            //     window.location.reload();
            // }
          }}
        />
      </Container>
    </>
  )
}

export default TaxExemption